import path from "path";

/**
 * adapts the extension of old path to new path if necessary.
 * Example:
 *
 * ("old_script.ls", "newScript") => "newScript.ls"
 * ("old_script.ls", "newScript.") => "newScript.ls"
 * (".old", ".new") => ".new"
 * ("old_script.ls", "newScript.groovy") => "newScript.groovy"
 *
 * @param {string} oldFileName
 * @param {string} newFileName
 *
 * @return {string}
 *
 * */
export function adaptFileExtension(oldFileName, newFileName) {
    let newExtname = path.extname(newFileName);
    if (newExtname === '.' || newExtname === '') {
        if (newFileName.indexOf(".") !== 0) {
            let oldExtName = path.extname(oldFileName);
            let newDir = path.dirname(newFileName);
            let baseName = path.basename(newFileName, newExtname);
            return path.join(newDir, baseName + oldExtName);
        }
    }
    return newFileName;
}

